/**
 * Garden geometry. The map format and planting rules live in @thicket/core
 * (garden-map.ts) so the server, the Claude connector and the app agree on
 * where things can grow; this re-exports them with the scene size.
 */
import { COLS, ROWS, TILE } from '@thicket/core';

export {
  anchorOf, COLS, isPlantable, isWalkable, letterAt, mapFor, parseMap, PLACEHOLDER_MAP, PLANTABLE, ROWS, TILE, tileAt, tileKey,
  type BiomeMap,
} from '@thicket/core';

export const W = COLS * TILE;
export const H = ROWS * TILE;
